import { render, staticRenderFns } from "./DealsList.vue?vue&type=template&id=4fac3b73&"
import script from "./DealsList.vue?vue&type=script&lang=js&"
export * from "./DealsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports